import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const md = {
  h1: (p) => <h3 className="mb-2 mt-3 text-base font-semibold first:mt-0" {...p} />,
  h2: (p) => <h3 className="mb-2 mt-3 text-base font-semibold first:mt-0" {...p} />,
  h3: (p) => <h4 className="mb-1.5 mt-3 text-sm font-semibold first:mt-0" {...p} />,
  p: (p) => <p className="mb-2 leading-relaxed last:mb-0" {...p} />,
  ul: (p) => <ul className="mb-2 list-disc space-y-1 pl-5" {...p} />,
  ol: (p) => <ol className="mb-2 list-decimal space-y-1 pl-5" {...p} />,
  hr: () => <hr className="my-3 border-border/60" />,
  a: (p) => <a className="text-primary underline underline-offset-2" target="_blank" rel="noreferrer" {...p} />,
  code: (p) => <code className="rounded bg-muted px-1 py-0.5 text-xs" {...p} />,
  table: (p) => (
    <div className="my-2 overflow-x-auto rounded-lg border border-border/60">
      <table className="w-full text-xs" {...p} />
    </div>
  ),
  thead: (p) => <thead className="bg-muted/60" {...p} />,
  th: (p) => <th className="px-3 py-2 text-left font-semibold" {...p} />,
  td: (p) => <td className="border-t border-border/50 px-3 py-2" {...p} />,
};

export const MessageContent = ({ content, isUser }) =>
  isUser ? (
    <p className="whitespace-pre-wrap text-sm leading-relaxed">{content}</p>
  ) : (
    <div className="text-sm" data-testid="chat-assistant-markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={md}>{content}</ReactMarkdown>
    </div>
  );
